module.exports = __webpack_public_path__ + "media/images/logos/purebarre-logo-19eca409df96c11d2c9ee26cfddc9f91.svg";